var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFriendsIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 74,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 20c0 10-9 22-19 22S20 30 20 20C20 9 29 0 39 0s19 9 19 20ZM43 63v5c0 7 9 6-4 6-21 0-39 2-39-10s17-22 39-22c9 0 11 0 18 3 5 4 0 6-5 9-4 2-9 5-9 9ZM84 36c0 8-6 16-13 16s-13-8-13-16c0-7 6-13 13-13s13 6 13 13Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96 66c0 9-11 7-25 7-15 0-26 2-26-7 0-8 11-15 26-15 14 0 25 7 25 15ZM28 37h22v6l5 2H22l6-2 1-1v-3l-1-2Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63 48h16l-1 1v2l1 1 3 1H59l4-1 1-1v-2l-1-1Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendsIconDark);
export default __webpack_public_path__ + "static/media/friends_icon_dark.fd7fb1d77c326687ae03cb4ed1f8505b.svg";
export { ForwardRef as ReactComponent };